<template>
  <v-row>
    <v-col cols="12" md="6" lg="4">
      <form-group :validator="$v.form.name" name="name" attribute="fields.name">
        <template slot-scope="{ attrs, listeners }">
          <v-text-field
            dense
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.name"
          ></v-text-field>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group name="tourism_city" attribute="fields.tourism_city_id">
        <template slot-scope="{ attrs, listeners }">
          <v-autocomplete
            dense
            :items="tourism_cities"
            hide-selected
            item-text="name"
            item-value="id"
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.tourism_city"
          ></v-autocomplete>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <form-group name="category" attribute="fields.category">
        <template slot-scope="{ attrs, listeners }">
          <v-autocomplete
            dense
            :items="place_categories"
            hide-selected
            item-text="name"
            item-value="id"
            v-bind="attrs"
            v-on="listeners"
            outlined
            v-model="form.category"
          ></v-autocomplete>
        </template>
      </form-group>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-text-field
        dense
        :label="$t('fields.address_line_one')"
        outlined
        v-model="form.address.address_line_one"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-text-field
        :label="$t('fields.address_line_two')"
        dense
        outlined
        v-model="form.address.address_line_two"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-text-field
        :label="$t('fields.postal_code')"
        dense
        type="number"
        outlined
        v-model="form.address.postal_code"
      ></v-text-field>
    </v-col>

    <v-col cols="12" md="6" lg="4">
      <v-select
        :label="$t('fields.country_id')"
        dense
        outlined
        :items="countries"
        item-text="name"
        item-value="id"
        v-model="form.address.country_id"
      ></v-select>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-select
        :label="$t('fields.state_id')"
        :disabled="states.length === 0"
        dense
        :items="states"
        item-text="name"
        item-value="id"
        outlined
        v-model="form.address.state_id"
      ></v-select>
    </v-col>
    <v-col cols="12" md="6" lg="4">
      <v-select
        :label="$t('fields.city_id')"
        :disabled="cities.length === 0"
        dense
        :items="cities"
        item-text="name"
        item-value="id"
        outlined
        v-model="form.address.city_id"
      ></v-select>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        multiple
        chips
        small-chips
        deletable-chips
        :label="$t('fields.tags')"
        dense
        :items="tags"
        item-text="name"
        item-value="id"
        outlined
        v-model="form.tags"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" lg="3">
      <v-switch
        true-value="1"
        false-value="0"
        :label="$t('table.is_visible')"
        v-model="form.visible"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <v-switch
        true-value="1"
        false-value="0"
        :label="$t('table.is_free')"
        v-model="form.free"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <v-switch
        true-value="1"
        false-value="0"
        :label="$t('table.is_approved')"
        v-model="form.approved"
      ></v-switch>
    </v-col>
    <v-col cols="12" md="6" lg="3">
      <v-switch
        true-value="1"
        false-value="0"
        :label="$t('table.premium')"
        v-model="form.premium"
      ></v-switch>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FirstStep",
  props: {
    countries: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    place_categories: {
      type: Array,
      default: () => []
    },

    states: {
      type: Array,
      default: () => []
    },
    tourism_cities: {
      type: Array,
      default: () => []
    },
    cities: {
      type: Array,
      default: () => []
    },
    place_types: {
      type: Array,
      default: () => []
    },

    form: {
      type: Object,
      default: () => {}
    },

    isEdit: {
      type: Boolean,
      default: false
    }
  },
  inject: ["$v"],
  data() {
    return {};
  },
  methods: {}
};
</script>
